export default __webpack_public_path__ + "static/media/now.7efd0ac0.svg";